import * as moment from "moment";

import { CurrentUser, LinkObject } from "@teamprevent/common/model";
import { CustomerUserCaseTypeOrgStructures } from "@teamprevent/common/customerUser/models";
import { UserRegistrationStatus } from "@teamprevent/common/models/core";

import { OrgStructure } from "../orgStructure";
import { CustomerSraDepartment } from "../customerSraDepartment";
import { CustomerState } from "../customer/model";

import { Location } from "redux-little-router";

export const ALL_GENERIC_CASE_TYPES = "All";

export interface CustomerUserListModel {
    readonly id: string;
    readonly emailAddress?: string;
    readonly firstName?: string;
    readonly surname?: string;
    readonly mobileNumber?: string;
    readonly active?: boolean;
    readonly listUpdated?: moment.Moment;
}

export interface CustomerUserDetailModel {
    readonly id: string;
    readonly customerId?: string;
    readonly emailAddress?: string;
    readonly firstName?: string;
    readonly surname?: string;
    readonly mobileNumber?: string;
    readonly roles?: string[];
    readonly orgStructureOne?: LinkObject;
    readonly orgStructureTwo?: LinkObject;
    readonly orgStructureThree?: LinkObject;
    readonly orgStructureFour?: LinkObject;
    readonly caseTypeOrgStructures?: CustomerUserCaseTypeOrgStructures[];
    readonly active?: boolean;
    readonly detailUpdated?: moment.Moment;
    readonly isMultiFactorAuthenticationEnabled?: boolean;
    readonly sraDepartments?: string[];
    readonly sraDepartmentNames?: string[];
    readonly registrationStatus?: UserRegistrationStatus;
    readonly registeredEmailAddress?: string;
    readonly lockOrgLevelOneForCaseCreation: boolean;
    readonly genericCaseTypeViewPermissions: LinkObject[];
}

export type CustomerUser = CustomerUserListModel & CustomerUserDetailModel;

export interface CustomerUserCreateModel {
    id: string;
    customerId: string;
    emailAddress: string;
    firstName: string;
    surname: string;
    mobileNumber: string;
    roles: string[];
    orgStructureOne?: LinkObject;
    orgStructureTwo?: LinkObject;
    orgStructureThree?: LinkObject;
    orgStructureFour?: LinkObject;
    caseTypes: string[];
    caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[];
    isMultiFactorAuthenticationEnabled: boolean;
    sraDepartments?: string[];
    lockOrgLevelOneForCaseCreation: boolean;
    genericCaseTypeViewPermissions: LinkObject[];
    genericCaseTypeViewPermissionsEnabled: boolean;
}

export interface CustomerUserEditModel {
    id: string;
    emailAddress: string;
    firstName: string;
    surname: string;
    mobileNumber: string;
    roles: string[];
    orgStructureOne?: LinkObject;
    orgStructureTwo?: LinkObject;
    orgStructureThree?: LinkObject;
    orgStructureFour?: LinkObject;
    caseTypes: string[];
    caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[];
    isMultiFactorAuthenticationEnabled: boolean;
    sraDepartments?: string[];
    lockOrgLevelOneForCaseCreation: boolean;
    genericCaseTypeViewPermissions: LinkObject[];
    genericCaseTypeViewPermissionsEnabled: boolean;
}

export interface CustomerUserState {
    readonly customerUsers: CustomerUser[];
    readonly orgStructures: OrgStructure[];
    readonly customerSraDepartments: CustomerSraDepartment[];
}

export type AppState = CustomerUserState & { router: Location } & { currentUser: CurrentUser} & CustomerState;
